import * as React from "react";
import Header from "./Header";
import PaymentRequestList from "../contract/legal/payments/PaymentRequestList";
import PaymentRequestForm from "../contract/legal/payments/PaymentRequestForm";

export default function LayoutPaymentRequests({ detail }) {
  return (
    <>
      <Header />
      {detail ? <PaymentRequestForm /> : <PaymentRequestList />}
    </>
  );
}
